import React, { useEffect, useState } from 'react';
import { LockIcon } from 'lucide-react';
type CheckoutCoverProps = {
  isVisible: boolean;
  /** Same cart URL already in flight, exposed only by the failsafe. */
  fallbackUrl: string;
};

/** Only if the navigation never happens do we offer a way out. */
const FAILSAFE_AFTER_MS = 8000;
export function CheckoutCover({
  isVisible,
  fallbackUrl
}: CheckoutCoverProps) {
  const [hasFailed, setHasFailed] = useState(false);
  useEffect(() => {
    if (!isVisible) {
      setHasFailed(false);
      return;
    }
    const timer = window.setTimeout(() => setHasFailed(true), FAILSAFE_AFTER_MS);
    return () => window.clearTimeout(timer);
  }, [isVisible]);
  if (!isVisible) return null;
  return <div className="cover-root" role="status" aria-live="polite" data-id="element-20" data-mp="3nvh1ythl5vab">
      <p className="cover-chrome" data-id="element-21" data-mp="27ijwu1j6os89">
        <LockIcon style={{
        width: 11,
        height: 11
      }} aria-hidden="true" data-id="element-22" data-mp="27hh8a09c31vi" />
        pagamento sicuro
      </p>

      <div className="cover-stage" data-id="element-23" data-mp="2ciy8dtjzukb1">
        <div className="cover-track" data-id="element-24" data-mp="3ke3xpi2zyhln">
          <div className="cover-ground" aria-hidden="true" data-id="element-25" data-mp="3kf59joru784f" />
          <div className="cover-travel" data-id="element-26" data-mp="3ff0rvvf707cm">
            <div className="cover-shadow" aria-hidden="true" data-id="element-27" data-mp="3fg2e8w1nsg9n" />
            <div className="cover-bob" data-id="element-28" data-mp="3uc9uxmduyzk6">
              <WalkingRobot data-id="element-29" data-mp="3ud1j4c54lv0f" />
            </div>
          </div>
        </div>

        <p className="cover-line" data-id="element-30" data-mp="3pcni3e1xzlbw">
          Ti portiamo al pagamento sicuro
          <span className="cover-dots" aria-hidden="true" data-id="element-31" data-mp="77kb1nsf0z8u">
            <span data-id="element-32" data-mp="75ze5rimp47t" />
            <span data-id="element-33" data-mp="75hesm0o69vo" />
            <span data-id="element-34" data-mp="28qx5u97v685" />
          </span>
        </p>
        <p className="cover-sub" data-id="element-35" data-mp="27pi7ep2xzl5">Stasera si tira fuori il cartone e si spegne il telefono.</p>

        {hasFailed ? <a href={fallbackUrl} className="cover-fallback" data-id="element-36" data-mp="gwlu5mu9bwr1">
            Vai al pagamento
          </a> : null}
      </div>

      <p className="cover-foot" data-id="element-37" data-mp="pxsb1x0tj9kt">powered by shopify</p>
    </div>;
}

/** Small cardboard robot walking: bobbing, arms and legs swinging out of phase. */
function WalkingRobot() {
  return <svg className="cover-robot" viewBox="0 0 64 72" width="64" height="72" fill="none" aria-hidden="true" data-id="element-38" data-mp="szofe7idnydd">
      <g className="cover-antenna" data-id="element-39" data-mp="xzj6oc62epyy">
        <line x1="32" y1="7" x2="32" y2="12" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-40" data-mp="xwesclyvyduk" />
        <circle cx="32" cy="4" r="3" fill="#7FBF6B" data-id="element-41" data-mp="17pvovxqeq71x" />
      </g>

      {/* head */}
      <rect x="18" y="12" width="28" height="22" rx="7" fill="#FBF7EF" stroke="#1B2C4F" strokeWidth="2.5" data-id="element-42" data-mp="1bpcwawpe9e9q" />
      <circle cx="26" cy="23" r="2.2" fill="#1B2C4F" data-id="element-43" data-mp="1lo2aaee66ekp" />
      <circle cx="38" cy="23" r="2.2" fill="#1B2C4F" data-id="element-44" data-mp="1lmhk10yw1hsn" />
      <line x1="25" y1="29" x2="39" y2="29" stroke="#C8912B" strokeWidth="2.5" strokeLinecap="round" data-id="element-45" data-mp="1qm3vp5z2ipzc" />

      <line x1="32" y1="34" x2="32" y2="38" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-46" data-mp="3sei8xrqo369f" />

      {/* body: a cardboard box, flaps taped across */}
      <rect x="16" y="38" width="32" height="22" rx="4" fill="#FBF7EF" stroke="#1B2C4F" strokeWidth="2.5" data-id="element-47" data-mp="24rw3ibiw94ei" />
      <line x1="16" y1="38" x2="48" y2="60" stroke="#1B2C4F" strokeWidth="1.3" opacity="0.4" data-id="element-48" data-mp="1vsiol3c03nme" />
      <line x1="48" y1="38" x2="16" y2="60" stroke="#1B2C4F" strokeWidth="1.3" opacity="0.4" data-id="element-49" data-mp="2si9kn6zxxiub" />

      <g className="cover-arm-left" data-id="element-50" data-mp="2oh7l0p2434rt">
        <line x1="16" y1="44" x2="6" y2="52" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-51" data-mp="2oi985rwejhpw" />
        <circle cx="6" cy="52" r="1.8" fill="#1B2C4F" data-id="element-52" data-mp="2ejjn5q97lh5f" />
      </g>
      <g className="cover-arm-right" data-id="element-53" data-mp="182ogez2mmn8h">
        <line x1="48" y1="44" x2="58" y2="52" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-54" data-mp="183ps95rgvdr9" />
        <circle cx="58" cy="52" r="1.8" fill="#1B2C4F" data-id="element-55" data-mp="2qzrftz34mm7k" />
      </g>

      <g className="cover-leg-left" data-id="element-56" data-mp="2qyges712fsk5">
        <line x1="24" y1="60" x2="22" y2="70" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-57" data-mp="2vr9j4tsmgyvp" />
        <line x1="18" y1="70" x2="26" y2="70" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-58" data-mp="2myfzkk657dc1" />
      </g>
      <g className="cover-leg-right" data-id="element-59" data-mp="3epvnqincl84d">
        <line x1="40" y1="60" x2="42" y2="70" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-60" data-mp="3eou5nu7wzld5" />
        <line x1="38" y1="70" x2="46" y2="70" stroke="#1B2C4F" strokeWidth="2.5" strokeLinecap="round" data-id="element-61" data-mp="35oe8f2hrlagq" />
      </g>
    </svg>;
}